module.exports = __webpack_public_path__ + "static/media/lolol_cash_voucher_app.9e207d40.jpg";